var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError500(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9102 78.3402L16.9102 53.5102L21.7702 50.7002L64.7702 75.5302L59.9102 78.3402Z",
    fill: "url(#paint0_linear_2903_18524)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9997 6.91979C51.1497 13.9198 60.9997 30.9198 60.9197 44.9198C60.8397 58.9198 50.9997 64.4898 38.8297 57.4798C26.6597 50.4698 16.8297 33.4798 16.9097 19.4798C16.9897 5.47979 26.8297 -0.0902064 38.9997 6.91979Z",
    fill: "url(#paint1_linear_2903_18524)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85 4.68023C36.74 1.15023 31.2 0.82023 27.2 3.15023L23.54 5.28023C27.52 3.08023 33 3.45023 39 6.92023C51.15 13.9202 61 30.9202 60.92 44.9202C60.92 51.6902 58.57 56.5002 54.79 58.8602H54.72C54.4 59.0602 58.38 56.7602 58.38 56.7602C62.38 54.4602 64.77 49.5802 64.79 42.6402C64.81 28.7002 55 11.6902 42.85 4.68023Z",
    fill: "url(#paint2_linear_2903_18524)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1102 3.91039V4.27039C32.5441 4.40403 35.8825 5.43865 38.7902 7.27039C50.7902 14.2104 60.5702 31.1104 60.5302 44.9204C60.5302 54.3204 55.9702 60.1504 48.7002 60.1504C45.2658 60.0191 41.9268 58.9843 39.0202 57.1504C27.0002 50.2104 17.2402 33.3204 17.2802 19.5004C17.2802 10.1104 21.8402 4.27039 29.1102 4.27039V3.91039ZM29.1102 3.91039C21.9002 3.91039 16.9402 9.62039 16.9102 19.5004C16.9102 33.5004 26.6802 50.5004 38.8302 57.5004C41.8035 59.3411 45.2053 60.3751 48.7002 60.5004C55.9102 60.5004 60.8702 54.7904 60.9002 44.9004C60.9002 30.9504 51.1302 13.9504 38.9802 6.90039C36.0091 5.05452 32.6059 4.02011 29.1102 3.90039V3.91039Z",
    fill: "url(#paint3_linear_2903_18524)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9297 49.79C37.8334 49.2078 36.9145 48.3407 36.2697 47.28C35.7457 46.3665 35.4666 45.3331 35.4597 44.28V43.28C35.4172 42.9055 35.4691 42.5264 35.6106 42.1771C35.7521 41.8278 35.9786 41.5194 36.2697 41.28C36.8097 40.93 37.6997 41.11 38.9297 41.82C40.012 42.3989 40.9147 43.2636 41.5397 44.32C42.0659 45.2326 42.345 46.2666 42.3497 47.32V48.32C42.4029 48.7025 42.3562 49.0923 42.2143 49.4515C42.0724 49.8107 41.84 50.1271 41.5397 50.37C40.9997 50.66 40.1297 50.49 38.9297 49.79ZM37.7697 38.16L35.9997 22.77V13L41.8097 16.36V26.09L40.1697 39.55L37.7697 38.16Z",
    fill: "url(#paint4_linear_2903_18524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2903_18524",
    x1: 29.9602,
    y1: 45.6802,
    x2: 53.1501,
    y2: 85.8402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2903_18524",
    x1: 38.8997,
    y1: 52.5898,
    x2: 38.8997,
    y2: 3.29979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2903_18524",
    x1: 18.07,
    y1: 14.0602,
    x2: 71.64,
    y2: 44.9902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2903_18524",
    x1: 27.9402,
    y1: 51.1904,
    x2: 49.8702,
    y2: 13.2104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F1F1F1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2903_18524",
    x1: 28.6597,
    y1: 26.33,
    x2: 47.1497,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500);
export default __webpack_public_path__ + "static/media/error500.7f9076725cbaccc59c572a2302e58e13.svg";
export { ForwardRef as ReactComponent };